import { snakeStore} from '@app/plugins/vuex-async-pagginate';

export const skills = snakeStore(
  {
    state: {
      trunks: [],
      selectedTrunk: null,
      serviceName: ''
    },
    mutations: {
      trunks: (state, value) => (state.trunks = value),
      selectedTrunk: (state, value) => (state.selectedTrunk = value),
      serviceName: (state, value) => (state.serviceName = value),
    },
    getters: {
      trunks: (state) => state.trunks,
      selectedTrunk: (state) => state.selectedTrunk,
      serviceName: (state) => state.serviceName,
    },
    actions: {
      setTrunks({ rootState, commit }, menu) {
        let service_name = rootState.prices.rates.table.serviceName;
        let menuWithSubPoints = menu?.filter((i) => i?.subPoints).map((i) => i.subPoints);
        // let trunksByService = flattenDeep(menuWithSubPoints)?.find((i) => i.name === service_name)
        //   ?.trunks;
        // commit('trunks', trunksByService);
      },
      setSelectedTrunk({ commit }, value) {
        commit('selectedTrunk', value);
      },
      setSelectedRate({ commit }, value) {
        commit('selectedRate', value);
      },
      setServiceName({ commit }, value) {
        commit('serviceName', value);
      }
    }
  },
  true
);
